import React, { createContext, useEffect, useRef, useState } from "react";

const SPUndoContext = createContext({});

export const SPUndoProvider = ({ children }) => {
  const positionEditsSP = useRef([]);
  const undoListSP = useRef([]);
  const [editIDSP, setEditIDSP] = useState(0);
  const [editingFieldSP, setEditingFieldSP] = useState(false);
  const [showcalculatorSP, setShowcalculatorSP] = useState();
  const inputRefsSP = useRef({});
  const [undoFocusFlagSP, setUndoFocusFlagSP] = useState();
  const [reloadpaytermsSP, setReloadpaytermsSP] = useState(false);

  return (
    <SPUndoContext.Provider
      value={{
        positionEditsSP,
        editIDSP,
        setEditIDSP,
        editingFieldSP,
        setEditingFieldSP,
        undoListSP,
        showcalculatorSP,
        setShowcalculatorSP,
        inputRefsSP,
        undoFocusFlagSP,
        setUndoFocusFlagSP,
        reloadpaytermsSP,
        setReloadpaytermsSP,
      }}
    >
      {children}
    </SPUndoContext.Provider>
  );
};

export default SPUndoContext;
